<template>
  <b-modal
    v-model="isOpen"
    has-modal-card
    trap-focus
    scroll="keep"
    aria-role="dialog"
    aria-label="PitchModale"
    :aria-modal="true"
    class="PitchModale"
    @cancel="emitCloseModale"
  >
    <div class="modal-card">
      <header class="modal-card-head modal-card-head-notes">
        {{ $t("pitchModale.title") }}
      </header>

      <section class="modal-card-body">
        {{ pitch }}
      </section>

      <footer class="modal-card-foot">
        <div class="buttons">
          <div class="hoverable-discrete-link mr-3" @click="emitCloseModale">
            {{ $t("annuler") }}
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BModal } from "buefy"

export default defineComponent({
  name: "PitchModale",
  components: { BModal },
  props: {
    pitch: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },

  emits: ["close-modale"],
  computed: {
    isOpen: {
      get(): boolean {
        return this.open
      },
      set(value: boolean): void {
        if (!value) {
          this.emitCloseModale()
        }
      },
    },
  },
  methods: {
    emitCloseModale(): void {
      this.$emit("close-modale")
    },
  },
})
</script>

<style lang="scss">
.PitchModale {
  &.modal .modal-card {
    height: 75%;
    overflow-y: auto !important;
  }

  .animation-content {
    height: 65%;
  }
}
</style>
